"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listNumberFormat = exports.bigLetterValue = exports.smallLetterValue = void 0;
var romanValue_1 = require("./romanValue");
var toWords_1 = require("./toWords");
/**
 * cache małych liter
 */
var SMALL_LETTERS_CACHE = [];
/**
 * cache wielkich liter
 */
var BIG_LETTERS_CACHE = [];
/**
 * uniwersalna funkcja do zamiany liczby na literę
 *
 * @param {number} value wartość
 * @param {number} startAsciiIndex startowy kod ASCII odpowiadający wartości 0
 * @param {string[]} cache cache wyników
 * @returns
 */
function letterValue(value, startAsciiIndex, cache) {
    if (cache[value] !== undefined) {
        return cache[value];
    }
    var result = '';
    if (value > 24) {
        var ivalue = value;
        result = '';
        while (ivalue > 0) {
            var nvalue = ivalue % 24;
            result = String.fromCharCode(nvalue + startAsciiIndex) + result;
            if (ivalue === nvalue) {
                break;
            }
            ivalue = Math.floor(ivalue / 24);
        }
    }
    else {
        result = value ? String.fromCharCode(value + startAsciiIndex) : '';
    }
    return (cache[value] = result);
}
/**
 * zamiana liczby na odpowiadającą jej małą literę
 * 1-a, 2-b ... 24-z, 25-aa, 26-ab
 *
 * @export
 * @param {number} value liczba
 * @returns {string} odpowidająca jej wartośc literowa
 */
function smallLetterValue(value) {
    return letterValue(value, 96, SMALL_LETTERS_CACHE);
}
exports.smallLetterValue = smallLetterValue;
/**
 * zamiana liczby na odpowiadającą jej wielką literę
 * 1-A, 2-B ... 24-Z, 25-AA, 26-AB
 *
 * @export
 * @param {number} value liczba
 * @returns {string} odpowidająca jej wartośc literowa
 */
function bigLetterValue(value) {
    return letterValue(value, 64, BIG_LETTERS_CACHE);
}
exports.bigLetterValue = bigLetterValue;
/**
 * Formatuje liczbe do tekstu wyswietlanego na liscie
 * @export
 * @param {number} value wartośc liczbowa
 * @param {string} [type='1.'] typ formatowania
 * @returns {string} sformatowany tekst
 */
function listNumberFormat(value, type) {
    if (type === void 0) { type = '1.'; }
    switch (type) {
        case '1':
            return value.toString();
        case '1.':
            return value + '.';
        case '1)':
            return value + ')';
        case '(1)':
            return '(' + value + ')';
        case '§':
        case '§ 1':
            return '§ ' + value;
        case '§ 1.':
            return '§ ' + value + '.';
        case 'a':
            return smallLetterValue(value);
        case 'a)':
            return smallLetterValue(value) + ')';
        case 'a.':
            return smallLetterValue(value) + '.';
        case '(a)':
            return '(' + smallLetterValue(value) + ')';
        case 'A':
            return bigLetterValue(value);
        case 'A)':
            return bigLetterValue(value) + ')';
        case 'A.':
            return bigLetterValue(value) + '.';
        case '(A)':
            return '(' + bigLetterValue(value) + ')';
        case 'i':
            return (0, romanValue_1.smallRomanValue)(value);
        case 'i.':
            return (0, romanValue_1.smallRomanValue)(value) + '.';
        case 'i)':
            return (0, romanValue_1.smallRomanValue)(value) + ')';
        case '(i)':
            return '(' + (0, romanValue_1.smallRomanValue)(value) + ')';
        case 'I':
            return (0, romanValue_1.bigRomanValue)(value);
        case 'I)':
            return (0, romanValue_1.bigRomanValue)(value) + ')';
        case 'I.':
            return (0, romanValue_1.bigRomanValue)(value) + '.';
        case '(I)':
            return '(' + (0, romanValue_1.bigRomanValue)(value) + ')';
        case 'abc':
            return (0, toWords_1.toWords)(value);
        case 'abc)':
            return (0, toWords_1.toWords)(value) + ')';
        case 'abc.':
            return (0, toWords_1.toWords)(value) + '.';
        default:
            return '*';
    }
}
exports.listNumberFormat = listNumberFormat;
exports.default = listNumberFormat;
//# sourceMappingURL=listNumberFormat.js.map